import { fromBaseRecord } from './from-base-context';

/** Install a decided row/cluster, retaining every unchanged held branch and alias. No snapshot or rollback. */
export function patchHeldValue(current: unknown, saved: unknown): unknown {
    if (current === saved) return current;
    if (Array.isArray(saved)) {
        const result: unknown[] = Array.isArray(current) ? current : [];
        for (let index = 0; index < saved.length; index++) result[index] = patchHeldValue(result[index], saved[index]);
        result.length = saved.length;
        return result;
    }
    if (fromBaseRecord(saved)) {
        const result = fromBaseRecord(current) ? current : {};
        for (const key of Object.keys(result)) if (!(key in saved)) delete result[key];
        for (const [key, value] of Object.entries(saved)) result[key] = patchHeldValue(result[key], value);
        return result;
    }
    return saved;
}
